class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'sidebar'
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile'

        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener(
                'click',
                this.tabActive.bind(this)
            );
        }
            
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener(
                'click',
                this.tabToggle.bind(this)
            );
        }

        document.addEventListener('click', e => {
            if (!this.contains(e.target)) return;
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e)
            }
            else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e)

            }
        });

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            document.querySelector('.background-overlay')?.addEventListener('click', this.onBackgroundClick.bind(this));
        }

        this.syncExpanded();
        window.addEventListener('resize', () => {
            if (this.activeDialog) this.closePopup();
            this.syncExpanded();
        });
        this.addEventListener('keydown', event => this.onPopupKeydown(event));
        this.focusGuard = event => {
            if (this.activeDialog && !this.activeDialog.contains(event.target)) this.focusPopup();
        };
        document.addEventListener('focusin', this.focusGuard);
        requestAnimationFrame(() => this.syncExpanded());
        setTimeout(() => {
            if (window.innerWidth > 550) {
                const $thisContent = document.getElementById('tab-description-mobile');
                if (!$thisContent) return;
                const tabHeight = $thisContent.offsetHeight;
                const maxHeight = parseInt($thisContent.querySelector('.tab-showMore')?.dataset.desMax);
                if (tabHeight < maxHeight) {
                    $thisContent.querySelector('.tab-showMore').remove();
                }
            }
        })
    }
    
    tabActive(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.currentTarget,
            id = $this.getAttribute('aria-controls'),
            button_tab = document.querySelector('.an-horizontal-shaking');

        if(!$this.classList.contains('is-open')) {
            this.tab.forEach((element, index) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');
            this.tabContents.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach((element, index) => {
                if(element.getAttribute('id') == id){
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }   

        if($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        if (this.classList.contains('layout-popup') && window.innerWidth > 550) {
            this.openPopup(document.getElementById(id), $this);
        }
        this.checkTabShowMore(id);
        this.syncExpanded();
    }

    tabToggle(event){
        event.preventDefault();
        event.stopPropagation();
        
        var $this = event.currentTarget,
            $thisContent = $this.parentNode.nextElementSibling;

        const popup = (window.innerWidth <= 550 && ($this.matches('.popup-mobile, .sidebar-mobile'))) || (window.innerWidth > 550 && this.isVerticalPopup);
        if (popup) {
            if (this.activeDialog === $thisContent) {
                this.closePopup();
            } else {
                $this.classList.add('is-open');
                $thisContent.classList.add('is-show');
                document.body.classList.add('tab-popup-show');
                if ($this.matches('.sidebar-mobile')) document.body.classList.add('tab-popup-sidebar-show');
                this.openPopup($thisContent, $this);
            }
        } else {
            const expanded = $this.classList.contains('is-open') || (window.innerWidth <= 550 && $this.classList.contains('show-mobile'));
            $this.classList.toggle('is-open', !expanded);
            $this.classList.remove('show-mobile');
            $thisContent.classList.remove('show-mobile');
            $($thisContent).stop(true, true)[expanded ? 'slideUp' : 'slideDown']('slow');
        }
        this.syncExpanded();
    }

    readMoreReadLess(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target.closest('[data-show-more-toogle]'),
            id = $this.getAttribute('aria-controls'),
            textShowMore = $this.getAttribute('data-show-more-text'),
            textShowLess = $this.getAttribute('data-show-less-text'),
            desMax = $this.closest('.tab-showMore').dataset.desMax;

        if($this.classList.contains('is-less')) {
            $this.closest('.tab-showMore').classList.remove('is-less');
            $this.classList.remove('is-less');
            $this.closest('.tab-showMore').classList.add('is-show');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            $this.setAttribute('aria-expanded', 'false');
            $this.setAttribute('aria-label', textShowMore + ' ' + ($this.dataset.labelContext || ''));
            document.getElementById(`${id}`).style.maxHeight = `${desMax}px`;
            this.tabContents.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        } else {
            $this.closest('.tab-showMore').classList.remove('is-show');
            $this.classList.remove('is-show');
            $this.closest('.tab-showMore').classList.add('is-less');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            $this.setAttribute('aria-expanded', 'true');
            $this.setAttribute('aria-label', textShowLess + ' ' + ($this.dataset.labelContext || ''));
            document.getElementById(`${id}`).style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.closePopup();
    }

    openPopup(panel, opener) {
        if (!panel || this.activeDialog === panel) return;
        if (this.activeDialog) this.closePopup(false);
        this.activeDialog = panel;
        this.popupOpener = opener;
        this.dialogAttributes = ['role', 'aria-modal', 'aria-label', 'tabindex'].map(name => [name, panel.getAttribute(name)]);
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-label', opener.textContent.trim());
        panel.setAttribute('tabindex', '-1');
        this.inertSiblings = [];
        for (let node = panel; node && node !== document.body; node = node.parentElement) {
            for (const sibling of node.parentElement.children) {
                if (sibling !== node && !sibling.inert && !sibling.matches('script, style, .background-overlay')) {
                    sibling.inert = true;
                    this.inertSiblings.push(sibling);
                }
            }
        }
        this.focusPopup();
    }

    popupFocusables() {
        return [...this.activeDialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex], video[controls], audio[controls]')]
            .filter(element => !element.disabled && element.tabIndex >= 0 && !element.closest('[inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    }

    focusPopup() {
        const panel = this.activeDialog;
        const focus = () => {
            if (this.activeDialog !== panel) return;
            const target = this.popupFocusables().find(element => element.matches('.pdViewTab-close')) || panel;
            target.focus({preventScroll: true});
        };
        focus();
        requestAnimationFrame(focus);
        setTimeout(() => {
            if (this.activeDialog === panel && !panel.contains(document.activeElement)) focus();
        }, 350);
    }

    onPopupKeydown(event) {
        if (!this.activeDialog) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.closePopup();
        } else if (event.key === 'Tab') {
            const items = this.popupFocusables();
            const first = items[0], last = items[items.length - 1];
            if (!first) {
                event.preventDefault();
                this.activeDialog.focus();
            } else if (event.shiftKey && (document.activeElement === first || document.activeElement === this.activeDialog)) {
                event.preventDefault(); last.focus();
            } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === this.activeDialog)) {
                event.preventDefault(); first.focus();
            }
        }
    }

    closePopup(restoreFocus = true) {
        const panel = this.activeDialog;
        const opener = this.popupOpener;
        this.activeDialog = null;
        if (panel) {
            panel.classList.remove('is-show');
            if (panel.matches('.tab-content')) panel.classList.remove('is-active');
            for (const [name, value] of this.dialogAttributes) {
                if (value === null) panel.removeAttribute(name);
                else panel.setAttribute(name, value);
            }
        }
        this.inertSiblings?.forEach(element => element.inert = false);
        this.inertSiblings = [];
        opener?.classList.remove('is-open', 'show-mobile');
        this.tabContents.classList.remove('is-show');
        document.body.classList.remove('tab-popup-show', 'tab-popup-sidebar-show');
        document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        this.syncExpanded();
        if (restoreFocus && opener?.isConnected) opener.focus({preventScroll: true});
    }

    syncExpanded() {
        this.tab.forEach(button => button.setAttribute('aria-expanded', String(button.classList.contains('is-open'))));
        this.link.forEach(button => {
            const content = document.getElementById(button.getAttribute('aria-controls'));
            const expanded = button.classList.contains('is-open') || (window.innerWidth <= 550 && button.classList.contains('show-mobile')) || content?.classList.contains('is-show');
            button.setAttribute('aria-expanded', String(Boolean(expanded)));
        });
    }

    checkTabShowMore(id) {
        if (window.innerWidth > 550) {
            const $thisContent = document.getElementById(`${id}`);
            if (!$thisContent) return;
                const tabHeight = $thisContent.offsetHeight;
            const maxHeight = parseInt($thisContent.querySelector('.tab-showMore')?.dataset.desMax);
            if (tabHeight < maxHeight) {
                $thisContent.querySelector('.tab-showMore').remove();
            }
        }
    }

    onBackgroundClick(event) {
        if (this.activeDialog && !this.activeDialog.contains(event.target)) this.closePopup();
    }

    handleVerticalPopupClose(event) {
        this.closePopup();
    }

    disconnectedCallback() {
        this.closePopup(false);
        document.removeEventListener('focusin', this.focusGuard);
    }
}

customElements.define('product-tab', ProductTabs);
